module.exports = __webpack_public_path__ + "_/assets/images/icons/icon-deposit-success-7cbe977fcae3c90f5e2e0aca77159ed3.svg";